import { createTheme, Theme } from '@mui/material';

declare module '@mui/styles' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

export const theme = createTheme({
  palette: {
    primary: {
      main: 'rgb(253, 182, 13)',
      contrastText: '#fff',
    },
    secondary: {
      main: '#FFF',
      contrastText: 'rgb(253, 182, 13)',
    },
    background: {
      default: '#fafafa',
    },
  },
});
